import { render, staticRenderFns } from "./ErrorGroup.vue?vue&type=template&id=80fc30e6&scoped=true"
import script from "./ErrorGroup.vue?vue&type=script&lang=js"
export * from "./ErrorGroup.vue?vue&type=script&lang=js"
import style0 from "./ErrorGroup.vue?vue&type=style&index=0&id=80fc30e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fc30e6",
  null
  
)

export default component.exports